module.exports = __webpack_public_path__ + "assets/5c466688ec8302c62fb8d026c74cb99b.png";